const ModificationLogTypes = {
    FETCH_MODIFICATION_LOG_START: 'FETCH_MODIFICATION_LOG_START',
    FETCH_MODIFICATION_LOG_SUCCESS: 'FETCH_MODIFICATION_LOG_SUCCESS',
    FETCH_MODIFICATION_LOG_FAILURE: 'FETCH_MODIFICATION_LOG_FAILURE'
  };
  
  export default ModificationLogTypes;